import setAppBarTitle from './setAppBarTitle';

export default {
	setAppBarTitle,
};
